import React, { Component } from 'react';
import { Button, Card, Form, message } from 'antd';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { BackBtn } from '@comm/BackBtn';
import FlowOp from '@comm/workflow/submitOp';
import { queryDeleteTermination, querySaveTermination } from '@api/incubator/termination';
import CardBase from '../detail/AddressBase';
import FormCheck from './FormCheck';
import FormTime from './FormTime';
import './end.less';

class PageAddressEnd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.files = [];
    this.businessInfo();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ dataInfo: nextProps.dataInfo });
  }

  /** 合同详情 */
  businessInfo = () => {
    const dataInfo = this.props.dataInfo || {};
    this.setState({
      dataInfo,
    });
  };

  terminationSave = params => {
    this.setState({
      submiting: true,
    });
    querySaveTermination(params).then(res => {
      this.setState({
        submiting: false,
      });
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/termination_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  handleChooseFile = params => {
    this.files = params;
    this.setState({
      showFileTips: params.length === 0,
    });
  };

  validateFile = () => {
    if (!this.files.length) {
      message.warn('没有选择附件！');
      this.setState({
        showFileTips: true,
      });
      return false;
    }
    return true;
  };

  handleDelete = uuid => {
    queryDeleteTermination({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        browserHistory.replace(`/incubator/termination_manage`);
      } else {
        message.error(res.message);
      }
    });
  };

  submit = op => e => {
    const { data } = this.props;
    const { dataInfo } = this.state;
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (!this.validateFile()) {
          return;
        }
        if (data) {
          values.uuid = data.uuid;
        }
        const params = {
          ...values,
          businessUuid: dataInfo.businessUuid,
          beginDate: moment(values.beginDate).format('YYYY-MM-DD'),
          endDate: moment(values.endDate).format('YYYY-MM-DD'),
          reason: values.reason,
          files: this.files,
          type: dataInfo.businessStatus.type, // 1异常终止

          // 地址终止付款约定的相关金额都为0
          damages: 0,
          refund: 0,
          obsolete: 0,
          liquidate: {},
        };
        if (op === 'audit') {
          this.terminationSave(params);
        } else {
          message.warn('保存草稿功能正在开发，敬请期待！');
        }
      }
    });
  };

  render() {
    const { data, dataInfo } = this.props;
    const { showFileTips, submiting } = this.state;
    return (
      <Form>
        <div style={{ marginBottom: 15 }}>
          <BackBtn />
          <FlowOp handleClick={this.submit} loading={submiting} />
          {data && data.uuid ? (
            <Button
              icon="delete"
              style={{ marginRight: 10 }}
              onClick={() => this.handleDelete(data.uuid)}
            >
              删除
            </Button>
          ) : null}
        </div>
        <CardBase dataInfo={dataInfo} {...this.props} />
        <Card title="终止条款" className="mb16">
          <FormTime {...this.props} dataInfo={dataInfo} />
        </Card>
        <FormCheck
          {...this.props}
          customUuid={dataInfo.customUuid}
          handleChooseFile={this.handleChooseFile}
          showFileTips={showFileTips}
        />
      </Form>
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(PageAddressEnd);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/end/AddressFree.js